/** Normalise a feature's `measures` property to a string[].
 *
 * Raw GeoJSON straight from the API carries `measures` as a real array, but
 * features returned from MapLibre click/query events have their array/object
 * properties JSON-stringified (GeoJSON sources are re-encoded to binary
 * vector-tile form so FeatureIndex can query them uniformly — see MapLibre's
 * GeoJSONWorkerSource). This accepts either form so consumers of clicked
 * features don't silently get an empty list.
 */
export function parseMeasureIds(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.filter((item): item is string => typeof item === "string");
  }
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed.filter((item): item is string => typeof item === "string");
      }
    } catch {
      // Not JSON — fall through to empty.
    }
  }
  return [];
}
